import { useSignals } from '@preact/signals-react/runtime';
import styled from 'styled-components';
import { sidebarBgColorItems } from './bgColorContains';
import { APPOINTMENT_STATUS, BLOCK_HOURS_CONFIG, BREAK_STAFF_CONFIG, CALENDAR_ITEM_TYPES, CANCEL_CONFIG, CHECK_IN_CONFIG, CONFIRM_CONFIG, GROUP_CONFIG, MULTI_CONFIG, NEW_CONFIG, NO_SHOW_CONFIG } from 'features/appointment/services/constants';

type SelectStatusConfigProps = {
  value?: string;
  onChange?: (value: string) => void;
};

const SelectStatusConfig = ({ value, onChange }: SelectStatusConfigProps) => {
  useSignals();

  return (
    <>
      {[
        // inline render for signals require, don't remove!
        {
          label: 'Multiple',
          value: 'MULTI',
          stroke: MULTI_CONFIG.value.stroke,
          fill: MULTI_CONFIG.value.fill,
        },
        {
          label: 'New',
          value: APPOINTMENT_STATUS.NEW,
          fill: NEW_CONFIG.value.fill,
          stroke: NEW_CONFIG.value.stroke,
        },
        {
          label: 'Confirm',
          value: APPOINTMENT_STATUS.CONFIRM,
          fill: CONFIRM_CONFIG.value.fill,
          stroke: CONFIRM_CONFIG.value.stroke,
        },
        {
          label: 'Check in',
          value: APPOINTMENT_STATUS.CHECK_IN,
          fill: CHECK_IN_CONFIG.value.fill,
          stroke: CHECK_IN_CONFIG.value.stroke,
        },
        {
          label: 'Cancel',
          value: APPOINTMENT_STATUS.CANCEL,
          fill: CANCEL_CONFIG.value.fill,
          stroke: CANCEL_CONFIG.value.stroke,
        },
        {
          label: 'No show',
          value: APPOINTMENT_STATUS.NO_SHOW,
          fill: NO_SHOW_CONFIG.value.fill,
          stroke: NO_SHOW_CONFIG.value.stroke,
        },
        {
          label: 'Staff break',
          value: CALENDAR_ITEM_TYPES.BREAK_STAFF,
          fill: BREAK_STAFF_CONFIG.value.fill,
          stroke: BREAK_STAFF_CONFIG.value.stroke,
        },
        {
          label: 'Block hours',
          value: CALENDAR_ITEM_TYPES.BLOCK_HOURS,
          fill: BLOCK_HOURS_CONFIG.value.fill,
          stroke: BLOCK_HOURS_CONFIG.value.stroke,
        },
        {
          label: 'Group',
          value: 'GROUP',
          fill: GROUP_CONFIG.value.fill,
          stroke: GROUP_CONFIG.value.stroke,
        },
      ].map((item, index) => (
        <StatusConfig
          key={index}
          $bgColor={item.fill}
          $isActive={value === item.value.toString()}
          onClick={() => onChange?.(item.value.toString())}
        >
          <div className='color-box' />
          <div className='text'>{item.label}</div>
        </StatusConfig>
      ))}
    </>
  );
};

export default SelectStatusConfig;

const StatusConfig = styled.div<{ $bgColor?: string; $isActive?: boolean }>`
  cursor: pointer;
  display: flex;
  padding: 16px 24px;
  align-items: center;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
  border-bottom: 1px solid #ccd4dc;
  background: ${({ $isActive }) => ($isActive ? '#6FABB6' : '#fff')};

  .color-box {
    display: flex;
    width: 48px;
    height: 48px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    aspect-ratio: 1/1;
    border-radius: 4px;
    background: ${({ $bgColor }) => $bgColor || '#fff'};
  }
  .text {
    color: ${({ $isActive }) => ($isActive ? '#fff' : '#505050')};
    font-size: 24px;
    font-weight: 500;
  }
`;
